module.exports = __webpack_public_path__ + "img/worksbot_img19121109.99a5af8a.jpg";